import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  fetchTaskChecklistAssignmentsByTaskId,
  type TaskChecklistAssignmentRow,
} from "@/lib/taskChecklistAssignmentRows";

export type { TaskChecklistAssignmentRow };

/**
 * Batch-fetch per-checklist assignments for many tasks (schedule timeline/calendar).
 */
export function usePropertyTaskChecklistAssignments(taskIds: string[]) {
  const stableKey = useMemo(() => [...taskIds].sort().join(","), [taskIds]);

  return useQuery({
    queryKey: ["property-task-checklist-assignments", stableKey],
    queryFn: () => fetchTaskChecklistAssignmentsByTaskId(taskIds),
    enabled: taskIds.length > 0,
    staleTime: 60_000,
  });
}
